import { Chip } from "@mui/material";
import Input from "../Base/Input";
import React from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import "../../Style/Theme/index.css";
import { randomAlphaNumeric } from "../../utils/utils";
import styles from "../../Style/Modules/captcha.module.css";

const Captcha = ({
  captchaMatched,
  setCaptchaMatched,
  randomCaptachData,
  setRandomCaptachData,
  setCaptchaData,
  captchaData,
}) => {
  const handleChange = (e) => {
    setCaptchaData(e?.target?.value);
    if (e?.target?.value == randomCaptachData) {
      setCaptchaMatched(true);
    } else {
      setCaptchaMatched(false);
    }
  };

  return (
    <div className={styles.captchaContainer}>
      <Chip className={`${styles.captchaChip}`} label={randomCaptachData} />
      <RefreshIcon
        className={styles.captchaRefreshIcon}
        onClick={() => {
          setRandomCaptachData(randomAlphaNumeric);
          setCaptchaMatched(false);
          setCaptchaData("");
        }}
      />
      <Input
        type="text"
        // className="captcha"
        autoComplete="off"
        name="captchaData"
        value={captchaData}
        error={!captchaMatched && captchaData}
        onChange={handleChange}
        label={"Captcha"}
        mb={0}
        // sx={{ border: "2px solid #29417c " }}
      />
    </div>
  );
};

export default Captcha;
